import React from "react";
import './Style/activities.css'
import { COMCards } from "../../Common/COMCards/COMCards";
import { Scards } from "../../SCards/Scards";
import activity1 from '../../../Global/assets/Digestive Glands.pdf'
import activity2 from '../../../Global/assets/Earthday3.gif'
import { Data } from "./ActivitiesData";
const Scard = (val) => {
    return (
        <Scards head={val.head} anchor={val.anchor} />
    )
}
const Activities = () => {
    return (
        <>
            <link rel="stylesheet" href="" />
            <div id="ExperimentsB" style={{height:'120vh'}}>
                {Data.map(Scard)}
            </div>
        </>
    )
}

export { Activities }